import { trackButtonClick } from '../../../analytics';

export default function Pricing() {
  return (
    <section id="pricing" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/d7a206-80e4-c3cb-1c31-418566081c4f_87ceb7af-752f-4afb-b8f9-9e25e5b9c5a3.png"
            alt="Content Creator"
            className="h-16"
          />
        </div>

        <div className="text-center mb-8">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            <span>Enroll Today For:</span>
          </h2>
        </div>

        {/* Pricing */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className="text-4xl md:text-5xl font-bold text-gray-400 line-through">$298</span>
            <span className="text-5xl md:text-6xl font-bold text-gray-900">$98</span>
          </div>
        </div>

        {/* Course Image */}
        <div className="max-w-4xl mx-auto mb-12">
          <img
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/bb81daf869b00bf1e657e03b1c8d360f.jpeg"
            alt="AI Creator Course"
            className="w-full"
          />
        </div>

        {/* CTA Box */}
        <div className="max-w-5xl mx-auto mb-12">
          <div className="bg-gray-900 text-white rounded-lg p-8 text-center shadow-lg">
            <h3 className="text-3xl font-bold mb-6">
              <span><em>THE AI CREATOR COURSE</em></span>
            </h3>
            <a
              href="/checkout"
              className="inline-block bg-green-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer"
              onClick={() => trackButtonClick('enroll_98', 'pricing')}
            >
              ENROLL FOR $98
            </a>
          </div>
        </div>

        {/* Guarantee */}
        <div className="text-center mb-8">
          {/* Removed guarantee text */}
        </div>

        {/* Trust Badges */}
        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          <div className="flex items-center gap-4">
            <img
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/301406f-3667-dec0-547e-b2203487667c_safe-checkout.png"
              alt="Safe Checkout"
              className="w-24 h-24 object-contain"
            />
            <p className="text-base font-semibold text-gray-900">Secure &amp; Safe Checkout</p>
          </div>
          <div className="flex items-center gap-4">
            <img
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/e0a85ee-1dde-28c-72a6-34c5aa77f81c_e7d4b4b9-1bed-4dcf-a2bd-1a0a5a68a2eb.png"
              alt="Money Back Guarantee"
              className="w-24 h-24 object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
